import {Fragment, useEffect, useState} from "react";
import {NODE_ROUTE_URI, PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {extractFullAddress, getCountryCode} from "../../Utils/Helper";
import {makeStyles} from "@mui/styles";
import {
    Autocomplete, Checkbox,
    FormControl,
    FormControlLabel, FormHelperText,
    FormLabel,
    Grid, MenuItem,
    Paper, Select,
    TextField,
    Typography
} from "@mui/material";

const useStyles = makeStyles({
    smallInput: {
        "& .MuiInputBase-input": {
            height: "0px", // Adjust the height as per your preference
            padding: "2px", // Adjust the padding as per your preference
            fontSize: "14px", // Adjust the font size as per your preference
        }
    }
});

export const house_type = [
    {propertyType: 'Residential', houseType: 'House'},
    {propertyType: 'Residential', houseType: 'Townhouse'},
    {propertyType: 'Residential', houseType: 'Apartment'},
    {propertyType: 'Residential', houseType: 'Curb Side'},
]

export const WordPressQuoteLocation = ({
                                           tab,
                                           validatedResult,
                                           cbHandleMovingFrom,
                                           cbHandleMovingTo,
                                           lng,
                                           movingSkid
                                       }) => {

    const classes = useStyles();

    const [movingFromAddressPredictions, setMovingFromAddressPredictions] = useState([]);
    const [movingToAddressPredictions, setMovingToAddressPredictions] = useState([]);
    const [movingFrom, setMovingFrom] = useState({
        streetAddress: null,
        apt: null,
        city: null,
        subCity: null,
        province: null,
        postalCode: null,
        country: tab?.toLowerCase() === 'brokerage' ? 'VN' : 'CA',
        propertyType: {
            houseType: "House",
            propertyType: "Residential"
        },
        floorLevel: '2',
        lift: 0,
        storey: '1',
        displayAddress: {
            description: null,
            placeId: null,
            text: null
        },
        displayPostalCode: {
            description: "",
            placeId: "",
            text: ""
        },
        option: 'schedule',
        warehouse: null,
        distanceFromTruckToDoor: "0 - 50m",
        // staircase: "Do not include the basement of your residence",
        staircaseNumber: 0,
        isNarrowStreet: false,
        isSteepDriveway: false,
        drivewaySteepLevel: 0,
        latitude: null,
        longitude: null
    });
    const [movingTo, setMovingTo] = useState({
        streetAddress: null,
        apt: null,
        city: null,
        subCity: null,
        province: tab?.toLowerCase() === 'brokerage' ? 'BC' : null,
        postalCode: null,
        country: 'CA',
        propertyType: {
            houseType: "Apartment",
            propertyType: "Residential"
        },
        floorLevel: '1',
        lift: 0,
        storey: '1',
        displayAddress: {
            description: null,
            placeId: null,
            text: null
        },
        displayPostalCode: {
            description: "",
            placeId: "",
            text: ""
        },
        displayProvince: {
            description: null,
            placeId: null,
            text: tab?.toLowerCase() === 'brokerage' ? 'British Columbia' : null
        },
        option: 'schedule',
        warehouse: null,
        distanceFromTruckToDoor: "0 - 50m",
        // staircase: "Do not include the basement of your residence",
        staircaseNumber: 0,
        isNarrowStreet: false,
        isSteepDriveway: false,
        drivewaySteepLevel: 0,
        latitude: null,
        longitude: null
    });

    const googleMapsPlaceAutocomplete = async (inputValue, type) => {
        let requestURL = `${PARTNER_URI}/searchPlace/placeAutocomplete`;

        try {
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    queryString: inputValue,
                    type: type,
                }
            })
            const {
                data: {
                    predictions = []
                }
            } = result;
            const updatedPredictions = predictions?.map(each => {
                return {
                    description: each?.description,
                    text: each?.structured_formatting?.main_text,
                    placeId: each?.place_id,
                    ...each
                }
            })
            return updatedPredictions;
        } catch (e) {
            console.log(e.response)
        }
    }

    // const googleMapsPlaceAutocomplete = async (inputValue, type) => {
    //     let requestURL = `${NODE_ROUTE_URI}/maps_apis/placeAutocomplete`;
    //
    //     try {
    //         const result = await axios({
    //             method: 'get',
    //             url: requestURL,
    //             params: {
    //                 input: inputValue,
    //                 types: type
    //             }
    //         })
    //         const {data: {data: {predictions}}} = result;
    //         console.log('prediction', predictions);
    //         const updatedPredictions = predictions?.map(each => {
    //             return {
    //                 description: each?.description,
    //                 text: each?.structured_formatting?.main_text,
    //                 placeId: each?.place_id
    //             }
    //         })
    //         console.log('updated prediction', updatedPredictions);
    //
    //         return updatedPredictions;
    //
    //     } catch (e) {
    //         console.log(e.response)
    //     }
    // }

    // const googleMapsPlaceAutocomplete = async (inputValue, type) => {
    //     let requestURL = `${PARTNER_URI}/googleMaps/placeAutocomplete`;
    //
    //     try {
    //         const result = await axios({
    //             method: 'get',
    //             url: requestURL,
    //             params: {
    //                 input: inputValue,
    //                 types: type
    //             }
    //         })
    //         const {data: {data: {predictions}}} = result;
    //         console.log('prediction', predictions);
    //         // TODO Map result in service
    //         const updatedPredictions = predictions?.map(each => {
    //             return {
    //                 description: each?.description,
    //                 text: each?.structured_formatting?.main_text,
    //                 placeId: each?.place_id
    //             }
    //         })
    //         console.log('updated prediction', updatedPredictions);
    //
    //         return updatedPredictions;
    //
    //     } catch (e) {
    //         console.log(e.response)
    //     }
    // }

    const googleMapsPlaceAutocompleteFromCountry = async (inputValue, type, country) => {
        let requestURL = `${PARTNER_URI}/searchPlace/placeAutocomplete`;

        try {
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    queryString: inputValue,
                    type: type,
                    country: country
                }
            })
            const {
                data: {
                    predictions = []
                }
            } = result;
            const updatedPredictions = predictions?.map(each => {
                return {
                    description: each?.description,
                    text: each?.structured_formatting?.main_text,
                    placeId: each?.place_id,
                    ...each
                }
            })
            return updatedPredictions;
        } catch (e) {
            console.log(e.response)
        }
    }

    // const googleMapsPlaceAutocompleteFromCountry = async (inputValue, type, country) => {
    //     let requestURL = `${PARTNER_URI}/googleMaps/placeAutocomplete`;
    //
    //     try {
    //         const result = await axios({
    //             method: 'get',
    //             url: requestURL,
    //             params: {
    //                 input: inputValue,
    //                 types: type,
    //                 country: country
    //             }
    //         })
    //         const {data: {data: {predictions}}} = result;
    //         console.log('prediction', predictions);
    //         // TODO Map result in service
    //         const updatedPredictions = predictions?.map(each => {
    //             return {
    //                 description: each?.description,
    //                 text: each?.structured_formatting?.main_text,
    //                 placeId: each?.place_id
    //             }
    //         })
    //         console.log('updated prediction', updatedPredictions);
    //
    //         return updatedPredictions;
    //
    //     } catch (e) {
    //         console.log(e.response)
    //     }
    // }

    // const googleMapsPlaceAutocompleteFromCountry = async (inputValue, type, country) => {
    //     let requestURL = `${NODE_ROUTE_URI}/maps_apis/placeAutocompleteFromCountry`;
    //
    //     try {
    //         const result = await axios({
    //             method: 'get',
    //             url: requestURL,
    //             params: {
    //                 input: inputValue,
    //                 types: type,
    //                 country: country
    //             }
    //         })
    //         const {data: {data: {predictions}}} = result;
    //         console.log('prediction', predictions);
    //         const updatedPredictions = predictions?.map(each => {
    //             return {
    //                 description: each?.description,
    //                 text: each?.structured_formatting?.main_text,
    //                 placeId: each?.place_id
    //             }
    //         })
    //         console.log('updated prediction', updatedPredictions);
    //
    //         return updatedPredictions;
    //
    //     } catch (e) {
    //         console.log(e.response)
    //     }
    // }

    const googleMapsPlaceDetails = async (placeId) => {
        let requestURL = `${NODE_ROUTE_URI}/maps_apis/placeDetails`;
        try {
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    placeId: placeId
                }
            });
            const place = result?.data?.data?.result;
            return place;

        } catch (e) {
            console.log(e.response)
        }
    }

    const googleMapsGeocoding = async (address) => {
        let requestURL = `${NODE_ROUTE_URI}/maps_apis/geocoding`;
        try {
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    address: address
                }
            });
            const place = result?.data?.data?.results?.[0];
            return place;

        } catch (e) {
            console.log(e.response)
        }
    }

    const getPlace = async (place) => {
        console.log('[getPlaceId] place', place?.text?.length);
        if (place?.text?.length === 3) {

            const predictionsAddress = await googleMapsPlaceAutocomplete(place?.text, 'postal_code');
            console.log('[getPlaceId] prediction address', predictionsAddress);

            const filterPrediction = predictionsAddress?.filter(item => item?.text?.length > 3);
            console.log('[getPlaceId] filterPrediction', filterPrediction);

            if (filterPrediction?.length > 0) {
                return filterPrediction?.[0];
            } else {
                return place;
            }
        } else {
            return place;
        }
    }

    const handleInputChangeMovingFromPostalCode = async (event, value) => {
        const predictionsAddress = tab === 'package' ? await googleMapsPlaceAutocompleteFromCountry(value, 'postal_code', movingFrom?.country) :
            await googleMapsPlaceAutocomplete(value, 'postal_code');
        setMovingFromAddressPredictions(predictionsAddress);
    }

    // const handleChangeMovingFromPostalCode = async (event, value) => {
    //
    //     console.log('[handleChangeMovingFromPostalCode] value', value);
    //
    //     const placeValue = await getPlace(value);
    //
    //     console.log('[handleChangeMovingFromPostalCode] place value', placeValue);
    //
    //     // const place = await googleMapsPlaceDetails(placeValue?.placeId);
    //     const place = await googleMapsGeocoding(placeValue?.description);
    //
    //     if (place) {
    //         const address = extractFullAddress(place);
    //         console.log('[handleChangeMovingFromPostalCode] address', address);
    //         console.log('[handleChangeMovingFromPostalCode] place', place);
    //
    //         setMovingFrom(prevState => ({
    //             ...prevState,
    //             city: address?.city || address?.administrative_area_level_3 || place?.vicinity || address?.sublocality || address?.neighborhood,
    //             subCity: place?.vicinity || address?.sublocality || address?.neighborhood,
    //             province: address?.state?.code,
    //             country: address?.country?.code,
    //             postalCode: address?.zip,
    //             displayPostalCode: placeValue,
    //             latitude: place?.geometry?.location?.lat,
    //             longitude: place?.geometry?.location?.lng
    //         }))
    //     } else {
    //         setMovingFrom(prevState => ({
    //             ...prevState,
    //             postalCode: '',
    //             city: '',
    //             subCity: '',
    //             province: '',
    //             displayPostalCode: {
    //                 ...prevState?.displayPostalCode,
    //                 description: '',
    //                 placeId: '',
    //                 text: ''
    //             },
    //             latitude: '',
    //             longitude: ''
    //         }))
    //     }
    // }

    // const handleChangeMovingFromPostalCode = async (event, value) => {
    //
    //     console.log('[ShippingLTLQuickQuoteAddress] handleInputShipFromPostalCode - value', value);
    //
    //     const {
    //         description,
    //         text,
    //         placeId,
    //         city,
    //         sub_city,
    //         metro_region_area,
    //         province,
    //         country,
    //         postalCode,
    //         sublocality,
    //         latitude,
    //         longitude
    //     } = value;
    //
    //     setMovingFrom(prevState => ({
    //         ...prevState,
    //         city: city,
    //         subCity:  sub_city,
    //         province: province,
    //         country: country,
    //         postalCode: postalCode,
    //         displayPostalCode: {
    //             description: description,
    //             placeId: placeId,
    //             text: text
    //         },
    //         latitude: latitude,
    //         longitude: longitude
    //     }))
    // }

    const getGeocoding = async ({address, placeId}) => {
        let requestURL = `${PARTNER_URI}/searchPlace/placeDetails`;
        const params = {
            placeId: placeId,
            text: address
        };
        try {
            const result = await axios({
                method: "get",
                url: requestURL,
                params: params
            });
            const place = result?.data;
            return place;

        } catch (e) {
            console.log(e.response);
        }
    };

    const handleChangeMovingFromPostalCode = async (event, value) => {
        // const place = await googleMapsPlaceDetails(value?.placeId);
        const {
            description,
            text,
            placeId,
            city,
            sub_city,
            metro_region_area,
            province,
            country,
            postalCode,
            sublocality,
            latitude,
            longitude
        } = value;

        const place = await getGeocoding({
            placeId,
            address: description
        });


        if (place) {
            const {
                address,
                address2,
                postal_code,
                neighborhood,
                sub_city,
                city,
                province,
                metro_region_area,
                country,
                longitude,
                latitude
            } = place;

            setMovingFrom(prevState => ({
                ...prevState,
                displayPostalCode: {
                    description: description,
                    placeId: placeId,
                    text: text
                },
                latitude: latitude,
                longitude: longitude,
                postalCode: postal_code,
                city: city,
                province: province,
                country: country,
            }));

            // const address = extractFullAddress(place);
            // setMovingFrom(prevState => ({
            //   ...prevState,
            //   postalCode: address?.zip,
            //   city: address?.city,
            //   province: address?.state,
            //   country: address?.country?.code,
            //   displayPostalCode: value,
            //   latitude: place?.geometry?.location?.lat,
            //   longitude: place?.geometry?.location?.lng
            // }));
        } else {
            setMovingFrom(prevState => ({
                ...prevState,
                postalCode: "",
                displayPostalCode: {
                    ...prevState?.displayPostalCode,
                    description: "",
                    placeId: "",
                    text: ""
                },
                latitude: "",
                longitude: ""
            }));
        }
    };


    const handleMovingFromCountry = event => {
        setMovingFrom(prevState => ({
            ...prevState,
            country: event?.target?.value,
            city: '',
            subCity: '',
            province: '',
            displayPostalCode: {
                ...prevState?.displayPostalCode,
                description: '',
                placeId: '',
                text: ''
            },
            latitude: '',
            longitude: ''

        }))
    }

    const handleMovingToCountry = event => {

        if (tab?.toLowerCase() === 'brokerage') {
            setMovingTo(prevState => ({
                ...prevState,
                country: event?.target?.value,
                city: '',
                subCity: '',
                province: event?.target?.value === 'CA' ? 'BC' : event?.target?.value === 'US' ? 'CA' : event?.target?.value === 'MX' ? 'Jal.' : '',
                displayPostalCode: {
                    ...prevState?.displayPostalCode,
                    description: '',
                    placeId: '',
                    text: ''
                },
                displayProvince: {
                    ...prevState?.displayProvince,
                    description: '',
                    placeId: '',
                    text: event?.target?.value === 'CA' ? 'British Columbia' : event?.target?.value === 'US' ? 'California' : event?.target?.value === 'MX' ? 'Jalisco' : ''
                },
                latitude: '',
                longitude: ''
            }))
        } else {
            setMovingTo(prevState => ({
                ...prevState,
                country: event?.target?.value,
                city: '',
                subCity: '',
                province: '',
                displayPostalCode: {
                    ...prevState?.displayPostalCode,
                    description: '',
                    placeId: '',
                    text: ''
                },
                displayProvince: {
                    ...prevState?.displayProvince,
                    description: '',
                    placeId: '',
                    text: ''
                },
                latitude: '',
                longitude: ''
            }))
        }
    }

    const handleInputChangeMovingToPostalCode = async (event, value) => {
        const predictionsAddress = tab === 'package' ? await googleMapsPlaceAutocompleteFromCountry(value, 'postal_code', movingTo?.country) :
            await googleMapsPlaceAutocomplete(value, 'postal_code');
        setMovingToAddressPredictions(predictionsAddress);
    }

    const handleChangeMovingToPostalCode = async (event, value) => {
        // const place = await googleMapsPlaceDetails(value?.placeId);
        const {
            description,
            text,
            placeId,
            city,
            sub_city,
            metro_region_area,
            province,
            country,
            postalCode,
            sublocality,
            latitude,
            longitude
        } = value;

        const place = await getGeocoding({
            placeId,
            address: description
        });


        if (place) {
            const {
                address,
                address2,
                postal_code,
                neighborhood,
                sub_city,
                city,
                province,
                metro_region_area,
                country,
                longitude,
                latitude
            } = place;

            setMovingTo(prevState => ({
                ...prevState,
                displayPostalCode: {
                    description: description,
                    placeId: placeId,
                    text: text
                },
                latitude: latitude,
                longitude: longitude,
                postalCode: postal_code,
                city: city,
                province: province,
                country: country,
            }));

            // const address = extractFullAddress(place);
            // setMovingFrom(prevState => ({
            //   ...prevState,
            //   postalCode: address?.zip,
            //   city: address?.city,
            //   province: address?.state,
            //   country: address?.country?.code,
            //   displayPostalCode: value,
            //   latitude: place?.geometry?.location?.lat,
            //   longitude: place?.geometry?.location?.lng
            // }));
        } else {
            setMovingTo(prevState => ({
                ...prevState,
                postalCode: "",
                displayPostalCode: {
                    ...prevState?.displayPostalCode,
                    description: "",
                    placeId: "",
                    text: ""
                },
                latitude: "",
                longitude: ""
            }));
        }
    };

    // const handleChangeMovingToPostalCode = async (event, value) => {
    //
    //     console.log('[ShippingLTLQuickQuoteAddress] handleInputShipFromPostalCode - value', value);
    //
    //     const {
    //         description,
    //         text,
    //         placeId,
    //         city,
    //         sub_city,
    //         metro_region_area,
    //         province,
    //         country,
    //         postalCode,
    //         sublocality,
    //         latitude,
    //         longitude
    //     } = value;
    //
    //     setMovingTo(prevState => ({
    //         ...prevState,
    //         city: city,
    //         subCity:  sub_city,
    //         province: province,
    //         country: country,
    //         postalCode: postalCode,
    //         displayPostalCode: {
    //             description: description,
    //             placeId: placeId,
    //             text: text
    //         },
    //         latitude: latitude,
    //         longitude: longitude
    //     }))
    // }

    // const handleChangeMovingToPostalCode = async (event, value) => {
    //
    //     const placeValue = await getPlace(value);
    //
    //     // const place = await googleMapsPlaceDetails(placeValue?.placeId);
    //     const place = await googleMapsGeocoding(placeValue?.description);
    //
    //     if (place) {
    //         const address = extractFullAddress(place);
    //         setMovingTo(prevState => ({
    //             ...prevState,
    //             city: address?.city || address?.administrative_area_level_3 || place?.vicinity || address?.sublocality || address?.neighborhood,
    //             subCity: place?.vicinity || address?.sublocality || address?.neighborhood,
    //             province: address?.state?.code,
    //             country: address?.country?.code,
    //             postalCode: address?.zip,
    //             displayPostalCode: placeValue,
    //             latitude: place?.geometry?.location?.lat,
    //             longitude: place?.geometry?.location?.lng
    //         }))
    //     } else {
    //         setMovingTo(prevState => ({
    //             ...prevState,
    //             postalCode: '',
    //             city: '',
    //             subCity: '',
    //             province: '',
    //             displayPostalCode: {
    //                 ...prevState?.displayPostalCode,
    //                 description: '',
    //                 placeId: '',
    //                 text: ''
    //             },
    //             latitude: '',
    //             longitude: ''
    //         }))
    //     }
    // }

    const handleInputChangeMovingToProvince = async (event, value) => {
        const predictionsAddress = await googleMapsPlaceAutocompleteFromCountry(value, 'administrative_area_level_1', movingTo?.country);
        setMovingToAddressPredictions(predictionsAddress);
    }

    const handleChangeMovingToProvince = async (event, value) => {

        // const place = await googleMapsPlaceDetails(value?.placeId);
        const place = await googleMapsGeocoding(value?.description);

        if (place) {
            const address = extractFullAddress(place);
            setMovingTo(prevState => ({
                ...prevState,
                province: address?.state?.code,
                country: address?.country?.code,
                displayProvince: value
            }))
        } else {
            setMovingTo(prevState => ({
                ...prevState,
                province: '',
                displayProvince: {
                    ...prevState?.displayProvince,
                    description: '',
                    placeId: '',
                    text: ''
                },
            }))
        }
    }

    const handleIsSelfDropOff = (event) => {
        setMovingFrom(prevState => ({
            ...prevState,
            option: event.target.checked ? 'self' : 'schedule',
            warehouse: null
        }))
    }

    const handleIsSelfPickup = (event) => {
        setMovingTo(prevState => ({
            ...prevState,
            option: event.target.checked ? 'self' : 'schedule',
            warehouse: null
        }))
    }

    const handleMovingFromPropertyType = (event, value) => {
        if (value?.houseType === 'House') {
            setMovingFrom(prevState => ({
                ...prevState,
                propertyType: value,
                floorLevel: "2",
                // lift: 0
            }))
        } else if (value?.houseType === 'Townhouse') {
            setMovingFrom(prevState => ({
                ...prevState,
                propertyType: value,
                // lift: 0,
                floorLevel: "3"
            }))
        } else {
            setMovingFrom(prevState => ({
                ...prevState,
                propertyType: value,
                floorLevel: "1"
                // lift: 1
            }))
        }
    }

    const handleMovingToPropertyType = (event, value) => {
        if (value?.houseType === 'House') {
            setMovingTo(prevState => ({
                ...prevState,
                propertyType: value,
                floorLevel: "2",
                // lift: 0
            }))
        } else if (value?.houseType === 'Townhouse') {
            setMovingTo(prevState => ({
                ...prevState,
                propertyType: value,
                // lift: 0,
                floorLevel: "3"
            }))
        } else {
            setMovingTo(prevState => ({
                ...prevState,
                propertyType: value,
                floorLevel: "1"
                // lift: 1
            }))
        }
    }

    useEffect(() => {
        cbHandleMovingFrom(movingFrom);
    }, [movingFrom]);

    useEffect(() => {
        cbHandleMovingTo(movingTo);
    }, [movingTo]);

    // useEffect(() => {
    //     if (movingSkid) {
    //         setMovingFrom(prevState => ({
    //             ...prevState,
    //             option: 'self',
    //             warehouse: null
    //         }));
    //         setMovingTo(prevState => ({
    //             ...prevState,
    //             option: 'self',
    //             warehouse: null
    //         }));
    //     }
    // },[movingSkid]);

    console.log('[WordPressQuoteLocation] movingToAddressPredictions', movingToAddressPredictions);

    return (
        <Fragment>
            {
                tab?.toLowerCase() === 'brokerage' ?
                    <>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required sx={{textAlign: 'left'}}>
                                    {lng === 'cn' ? '出口国家' : "Export Country"}
                                </FormLabel>
                                <Select
                                    sx={{
                                        '& .MuiSelect-select': {
                                            fontSize: '14px' // Set your desired font size here
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            padding: '5px 14px', // Removes inner padding
                                        },
                                    }}
                                    value={movingFrom?.country}
                                    size='small'
                                    onChange={handleMovingFromCountry}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                // width: 250,
                                            },
                                        },
                                    }}
                                    error={validatedResult !== null && !movingFrom?.country}
                                >
                                    {
                                        getCountryCode('ups', (tab === 'moving' || tab === 'car')).map(v => {
                                            return <MenuItem value={v.code}
                                                             sx={{fontSize: '14px'}}>{v.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <FormHelperText
                                    sx={{
                                        color: "error.main",
                                    }}
                                >
                                    {(validatedResult !== null && !movingFrom?.country) && (lng === 'cn' ? "必填" : "Required")}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel required sx={{textAlign: 'left'}}>
                                    {lng === 'cn' ? '进口国家' : "Import Country"}
                                </FormLabel>
                                <Select
                                    sx={{
                                        '& .MuiSelect-select': {
                                            fontSize: '14px' // Set your desired font size here
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            padding: '5px 14px', // Removes inner padding
                                        },
                                    }}
                                    value={movingTo?.country}
                                    size='small'
                                    onChange={handleMovingToCountry}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                // width: 250,
                                            },
                                        },
                                    }}
                                    error={validatedResult !== null && !movingTo?.country}
                                >
                                    {
                                        getCountryCode('ups', (tab === 'moving' || tab === 'car')).map(v => {
                                            return <MenuItem value={v.code}
                                                             sx={{fontSize: '14px'}}>{v.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <FormHelperText
                                    sx={{
                                        color: "error.main",
                                    }}
                                >
                                    {(validatedResult !== null && !movingTo?.country) && (lng === 'cn' ? "必填" : "Required")}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <FormControl fullWidth>
                                <FormLabel
                                    required={movingTo?.country === 'CA' || movingTo?.country === 'US' || movingTo?.country === 'MX'}
                                    sx={{textAlign: 'left'}}>
                                    {lng === 'cn' ? '进口省份' : "Import Province"}
                                </FormLabel>
                                <Autocomplete
                                    value={movingTo?.displayProvince}
                                    fullWidth
                                    options={movingToAddressPredictions}
                                    filterOptions={(options, state) => options}
                                    getOptionLabel={option => option?.text}
                                    onInputChange={handleInputChangeMovingToProvince}
                                    onChange={handleChangeMovingToProvince}
                                    renderInput={params => <TextField
                                        {...params}
                                        className={classes.smallInput}
                                        variant="outlined"
                                        error={validatedResult !== null && !movingTo?.province && (movingTo?.country === 'CA' || movingTo?.country === 'US' || movingTo?.country === 'MX')}
                                        helperText={(validatedResult !== null && !movingTo?.province && (movingTo?.country === 'CA' || movingTo?.country === 'US' || movingTo?.country === 'MX')) && (lng === 'cn' ? "必填" : "Required")}
                                    />}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            <Typography style={{fontSize: '12px'}}>
                                                {option.description}
                                            </Typography>
                                        </li>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </>
                    :
                    <>
                        <Grid size={{xs: 12, md: 6}}>
                            <Grid container spacing={4}>
                                {
                                    tab?.toLowerCase() === 'package' &&
                                    <Grid size={{xs: 12, md: 5}}>
                                        <FormControl fullWidth>
                                            <FormLabel required sx={{textAlign: 'left'}}>
                                                {lng === 'cn' ? '始发地国家' : "Departure Country"}
                                            </FormLabel>
                                            <Select
                                                sx={{
                                                    '& .MuiSelect-select': {
                                                        fontSize: '14px' // Set your desired font size here
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '5px 14px', // Removes inner padding
                                                        // height: '33px'
                                                    },
                                                }}
                                                value={movingFrom?.country}
                                                size='small'
                                                onChange={handleMovingFromCountry}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 48 * 4.5 + 8,
                                                            // width: 250,
                                                        },
                                                    },
                                                }}
                                                error={validatedResult !== null && !movingFrom?.country}
                                            >
                                                {
                                                    getCountryCode('ups', (tab === 'moving' || tab === 'car')).map(v => {
                                                        return <MenuItem value={v.code}
                                                                         sx={{fontSize: '14px'}}>{v.name}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText
                                                sx={{
                                                    color: "error.main",
                                                }}
                                            >
                                                {(validatedResult !== null && !movingFrom?.country) && (lng === 'cn' ? "必填" : "Required")}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                }
                                <Grid size={{
                                    xs: 12,
                                    md: tab?.toLowerCase() === 'package' ? 7 : tab?.toLowerCase() === 'moving' ? 8 : 12
                                }}>
                                    <FormControl fullWidth>
                                        <FormLabel required sx={{textAlign: 'left'}}>
                                            {lng === 'cn' ? '出发地邮编' : "Departure Postal Code"}
                                        </FormLabel>
                                        <Autocomplete
                                            // freeSolo
                                            value={movingFrom?.displayPostalCode}
                                            fullWidth
                                            options={movingFromAddressPredictions}
                                            filterOptions={(options, state) => options}
                                            getOptionLabel={option => option?.description}
                                            onInputChange={handleInputChangeMovingFromPostalCode}
                                            onChange={handleChangeMovingFromPostalCode}
                                            disabled={!movingFrom?.country}
                                            renderInput={params => <TextField
                                                {...params}
                                                className={classes.smallInput}
                                                variant="outlined"
                                                error={validatedResult !== null && !movingFrom?.postalCode}
                                                helperText={(validatedResult !== null && !movingFrom?.postalCode) && (lng === 'cn' ? "必填" : "Required")}
                                            />}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    <Typography style={{fontSize: '12px'}}>
                                                        {option.description}
                                                    </Typography>
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                {
                                    tab?.toLowerCase() === 'moving' &&
                                    <Grid size={{xs: 12, md: 4}}>
                                        <FormControl fullWidth>
                                            <FormLabel required>
                                                {lng === 'cn' ? '房屋类型' : "Property Type"}
                                            </FormLabel>
                                            <Autocomplete
                                                value={movingFrom.propertyType}
                                                fullWidth
                                                groupBy={(option) => option.propertyType}
                                                options={house_type}
                                                getOptionLabel={(option) => option.houseType}
                                                onChange={handleMovingFromPropertyType}
                                                renderInput={(params) => <TextField
                                                    variant="outlined"
                                                    className={classes.smallInput}
                                                    {...params}
                                                    error={validatedResult !== null && !movingFrom?.propertyType}
                                                    helperText={(validatedResult !== null && !movingFrom?.propertyType) && (lng === 'cn' ? "必填" : "Required")}
                                                />}
                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        <Typography style={{fontSize: '12px'}}>
                                                            {option.houseType}
                                                        </Typography>
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                                {
                                    tab?.toLowerCase() === 'moving' &&
                                    <Grid size={{xs: 12}}>
                                        <FormControl fullWidth>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={movingFrom?.option === 'self'}
                                                        onChange={handleIsSelfDropOff}
                                                        // disabled={movingSkid}
                                                        style={{
                                                            color: 'green',
                                                            '&.Mui-checked': {
                                                                color: 'green',
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <>
                                                        {lng === 'cn' ? '自行将货物送至我司仓库' : "Drop off at our warehouse by yourself"}
                                                    </>
                                                }
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid size={{xs: 12, md: 6}}>
                            <Grid container spacing={4}>
                                {
                                    tab?.toLowerCase() === 'package' &&
                                    <Grid size={{xs: 12, md: 5}}>
                                        <FormControl fullWidth>
                                            <FormLabel required sx={{textAlign: 'left'}}>
                                                {lng === 'cn' ? '目的地国家' : "Destination Country"}
                                            </FormLabel>
                                            <Select
                                                sx={{
                                                    '& .MuiSelect-select': {
                                                        fontSize: '14px' // Set your desired font size here
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '5px 14px', // Removes inner padding
                                                    },
                                                }}
                                                value={movingTo?.country}
                                                size='small'
                                                onChange={handleMovingToCountry}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 48 * 4.5 + 8,
                                                            // width: 250,
                                                        },
                                                    },
                                                }}
                                                error={validatedResult !== null && !movingTo?.country}
                                            >
                                                {
                                                    getCountryCode('ups', (tab === 'moving' || tab === 'car')).map(v => {
                                                        return <MenuItem value={v.code}
                                                                         sx={{fontSize: '14px'}}>{v.name}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText
                                                sx={{
                                                    color: "error.main",
                                                }}
                                            >
                                                {(validatedResult !== null && !movingTo?.country) && (lng === 'cn' ? "必填" : "Required")}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                }
                                <Grid size={{
                                    xs: 12,
                                    md: tab?.toLowerCase() === 'package' ? 7 : tab?.toLowerCase() === 'moving' ? 8 : 12
                                }}>
                                    <FormControl fullWidth>
                                        <FormLabel required sx={{textAlign: 'left'}}>
                                            {lng === 'cn' ? '目的地邮编' : "Destination Postal Code"}
                                        </FormLabel>
                                        <Autocomplete
                                            value={movingTo?.displayPostalCode}
                                            fullWidth
                                            options={movingToAddressPredictions}
                                            filterOptions={(options, state) => options}
                                            getOptionLabel={option => option?.description}
                                            onInputChange={handleInputChangeMovingToPostalCode}
                                            onChange={handleChangeMovingToPostalCode}
                                            renderInput={params => <TextField
                                                {...params}
                                                className={classes.smallInput}
                                                variant="outlined"
                                                error={validatedResult !== null && !movingTo?.postalCode}
                                                helperText={(validatedResult !== null && !movingTo?.postalCode) && (lng === 'cn' ? "必填" : "Required")}
                                            />}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    <Typography style={{fontSize: '12px'}}>
                                                        {option.description}
                                                    </Typography>
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                {
                                    tab?.toLowerCase() === 'moving' &&
                                    <Grid size={{xs: 12, md: 4}}>
                                        <FormControl fullWidth>
                                            <FormLabel required>
                                                {lng === 'cn' ? '房屋类型' : "Property Type"}
                                            </FormLabel>
                                            <Autocomplete
                                                value={movingTo.propertyType}
                                                fullWidth
                                                groupBy={(option) => option.propertyType}
                                                options={house_type}
                                                getOptionLabel={(option) => option.houseType}
                                                onChange={handleMovingToPropertyType}
                                                renderInput={(params) => <TextField
                                                    variant="outlined"
                                                    className={classes.smallInput}
                                                    {...params}
                                                    error={validatedResult !== null && !movingTo?.propertyType}
                                                    helperText={(validatedResult !== null && !movingTo?.propertyType) && (lng === 'cn' ? "必填" : "Required")}
                                                />}
                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        <Typography style={{fontSize: '12px'}}>
                                                            {option.houseType}
                                                        </Typography>
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                                {
                                    tab?.toLowerCase() === 'moving' &&
                                    <Grid size={{xs: 12}}>
                                        <FormControl fullWidth>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={movingTo?.option === 'self'}
                                                        onChange={handleIsSelfPickup}
                                                        // disabled={movingSkid}
                                                        style={{
                                                            color: 'green',
                                                            '&.Mui-checked': {
                                                                color: 'green',
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <>
                                                        {lng === 'cn' ? '自行来我司仓库提货' : "Self Pickup at our warehouse by yourself"}
                                                    </>
                                                }
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </>
            }
        </Fragment>
    )
}